<script lang="ts">
import { defineComponent, ref } from 'vue';
import { QrStream } from 'vue3-qr-reader';
import LoadingSpinner from './LoadingSpinner.vue';

export default defineComponent({
  name: 'QRCodeReader',
  props: {
    readQRCode: {
      type: Function,
      default: () => null,
    },
  },
  components: {
    QrStream,
    LoadingSpinner,
  },
  setup() {
    const isLoading = ref(true);

    const handleInit = (promise: Promise<any>) => {
      promise.then(() => {
        isLoading.value = false;
      });
    };

    return { handleInit, isLoading };
  },
});
</script>

<template>
  <div class="w-100 flex items-center flex-col mt-4">
    <div
      style="height: 200px; width: 200px"
      class="border-4 border-blue-800 rounded-3xl relative"
    >
      <LoadingSpinner :isLoading="isLoading" />
      <QrStream @decode="readQRCode" @init="handleInit">
        <div style="color: red" class="frame"></div>
      </QrStream>
    </div>
    <span class="mt-1">aponte para o qrcode</span>
  </div>
</template>

<style>
.qr-stream-camera {
  border-radius: 1.2rem;
}
</style>
